import { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const EMPTY = { name: '', email: '', password: '', role: 'client' };

/**
 * Alta de una persona con su rol.
 *
 * Hasta ahora la única forma de crear a alguien era el registro público, que
 * siempre asigna `client`, o el alta de modelos: no había manera de crear un
 * administrador desde la aplicación.
 */
export default function UserForm({ show, onHide, onSubmit }) {
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  // Cerrar sin guardar descarta lo escrito: si no, el siguiente usuario que se
  // fuera a crear heredaría los datos del intento anterior.
  useEffect(() => {
    if (show) {
      setForm(EMPTY);
      setError(null);
    }
  }, [show]);

  const change = (name, value) => setForm((prev) => ({ ...prev, [name]: value }));

  const submit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError(null);
    try {
      await onSubmit(form);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="profile-manager-modal">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fa-solid fa-user-plus me-2" aria-hidden="true"></i>
          Nuevo usuario
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={submit} className="profile-manager-form">
          {error && <div className="alert alert-danger py-2 small">{error}</div>}

          <Form.Label>Nombre</Form.Label>
          <Form.Control
            value={form.name}
            onChange={(e) => change('name', e.target.value)}
            required
            maxLength={120}
          />

          <Form.Label className="mt-3">Correo</Form.Label>
          <Form.Control
            type="email"
            value={form.email}
            onChange={(e) => change('email', e.target.value)}
            required
          />

          <Form.Label className="mt-3">Contraseña</Form.Label>
          <Form.Control
            type="password"
            value={form.password}
            onChange={(e) => change('password', e.target.value)}
            required
            minLength={8}
          />
          <Form.Text className="text-muted">Mínimo 8 caracteres.</Form.Text>

          <Form.Label className="mt-3">Rol</Form.Label>
          <Form.Select value={form.role} onChange={(e) => change('role', e.target.value)}>
            <option value="client">Cliente</option>
            <option value="model">Modelo</option>
            <option value="admin">Administrador</option>
            <option value="root">Root</option>
          </Form.Select>
          <Form.Text className="text-muted">
            Para dar de alta a una modelo con su perfil y su clave de emisión, usa
            la pantalla de Modelos: aquí solo se crea la cuenta.
          </Form.Text>

          <div className="pt-4">
            <Button type="submit" className="w-100 btn-save-profile" disabled={saving}>
              {saving ? 'Creando...' : 'Crear usuario'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
